const AuthProgress = {
  IDENTITY: 0,
  LOGIN: 1,
  SIGNUP: 2,
};
export default AuthProgress;
